import {Component, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {RouterOutlet} from '@angular/router';
import {LanguageService} from "../../../core/i18n/language.service";


@Component({
    selector: 'app-default-layout',
    templateUrl: './default-layout.component.html',
    styleUrls: ['./default-layout.component.scss'],
    imports: [DatePipe, RouterOutlet]
})
export class DefaultLayoutComponent implements OnInit {

    currentYear!: number;

    constructor(private readonly languageService: LanguageService) {
    }

    ngOnInit(): void {
        this.currentYear = Date.now();
    }

}
